import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Switch from '@material-ui/core/Switch'

import { connect } from 'react-redux'

import { listOfAmenities } from '../../utils/_DATA'
import { handleSaveOffice } from '../../actions/offices'
//import t from '../../utils/lang/office'

const styles = theme => ({
  root: {
    minWidth: '360px',
    width: '500px'
  },
  list: {
    width: '100%',
    minWidth: '300px',
  },
  listItem: {
    paddingLeft: '0'
  }
});

class AmenitiesDialog extends Component {
  state = {
    amenities: [],
  }

  componentDidMount() {
    const { data } = this.props

    //console.log(data.amenities)

    this.setState(() => ({
      amenities: data.amenities !== null ? data.amenities : [],
    }))
  }

  handleChangeAmenities = value => () => {
    const { amenities } = this.state;
    const currentIndex = amenities.indexOf(value);
    const newAmenities = [...amenities];

    if (currentIndex === -1) {
      newAmenities.push(value);
    } else {
      newAmenities.splice(currentIndex, 1);
    }

    this.setState({
      amenities: newAmenities,
    });
  };

  handleSaveData = e => {
    const { officeId, handleClose, dispatch } = this.props
    const data = JSON.stringify(this.state)

    dispatch(handleSaveOffice(officeId, data))

    handleClose()
  }

  render() {
    const { fullScreen, open, handleClose, classes } = this.props
    const { amenities } = this.state

    const lang = 'en'

    return (
      <div className={classes.list}>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">Edit amenities</DialogTitle>
          <DialogContent>
            <List className={classes.list}>
              {listOfAmenities[lang].map(a => (
                <ListItem key={a.id} className={classes.listItem}>
                  <ListItemText primary={a.title} />
                  <ListItemSecondaryAction>
                    <Switch
                      onChange={this.handleChangeAmenities(a.id.toString())}
                      checked={amenities.indexOf(a.id.toString()) !== -1}
                      value={a.id.toString()}
                    />
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleSaveData} color="primary" autoFocus>
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

AmenitiesDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  officeId: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired
};

function mapStateToProps ({ authedUser }) {
  return {
    userId: authedUser.id
  }
}

export default connect(mapStateToProps)(withStyles(styles)(withMobileDialog()(AmenitiesDialog)))


// WEBPACK FOOTER //
// ./src/components/Offices/AmenitiesDialog.js